import { rankWith, uiTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { useTranslation } from "react-i18next";
import { TRENDS } from "../../../constants/trends";
import getStyled from "../../../hooks/getStyled";
import { SFBadgeIcon } from "../../badgeIcon";
import { SFStack } from "../../grid";
import { SFTrendDownIcon, SFTrendingFlat, SFTrendUpIcon } from "../../icons";

const { styled } = getStyled();

const SFBadgeIconStyled = styled(SFBadgeIcon)(() => ({
  height: "100%",
}));

const getTrendBadge = (trend) => {
  let r;
  switch (trend) {
  case TRENDS.increasing:
    r = {
      description: trend,
      icon: <SFTrendUpIcon size="small" />,
      variant: "green",
    };
    break;
  case TRENDS.decreasing:
    r = {
      description: trend,
      icon: <SFTrendDownIcon size="small" />,
      variant: "red",
    };
    break;
  default:
    r = {
      description: trend,
      icon: <SFTrendingFlat size="small" />,
      variant: "maroon",
    };
    break;
  }
  return {
    description: (
      <SFStack direction="row" spacing={0.5} alignItems="center">
        {r.icon}
        <div>{r.description}</div>
      </SFStack>
    ),
    variant: r.variant,
    icon: r.icon,
  };
};

const BadgeRenderer = ({ data, uischema }) => {
  const { t } = useTranslation();

  const { i18nKey, variant, ignoreIcon, icon, isTrend } = uischema;

  if (isTrend) {
    return <SFBadgeIconStyled label={t(i18nKey)} {...getTrendBadge(data)} />;
  }

  return (
    <SFBadgeIconStyled
      label={t(i18nKey)}
      variant={variant}
      ignoreIcon={ignoreIcon}
      icon={icon}
      description={data}
    />
  );
};

export const BadgeTester = rankWith(101, uiTypeIs("Badge"));

export default withJsonFormsControlProps(BadgeRenderer);
